import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_image",
  "use": "icon_image-usage",
  "viewBox": "0 0 24 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 20\" id=\"icon_image\"><path d=\"M24,20H0V0H24V20ZM3.5,15.1a.473.473,0,0,0-.5.5.457.457,0,0,0,.5.4H20.6a.5.5,0,0,0,0-1H19.4L16.5,7.3c-.095-.19-.191-.3-.4-.3a.552.552,0,0,0-.5.3L12,12.7,9.9,10.2l-.1-.1a1.034,1.034,0,0,0-.315-.06c-.187,0-.286.09-.286.26L6.3,15.1ZM8,3a2,2,0,1,0,2,2A2,2,0,0,0,8,3Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol